import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AccountService } from '../../../services/account.service';
import { SCAMP_API } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable()
export class EstoqueService {

    constructor(
        private http: HttpClient,
        private account: AccountService
    ) { }

    submit(data: any) {
        return this.http.post(`${SCAMP_API.accountApiV1}/estoque`, data, { headers: this.account.composeHeaders() });
    }

    buscarPorId(id: number): Observable<any> {
        return this.http.get<any>(`${SCAMP_API.accountApiV1}/estoque/${id}`, { headers: this.account.composeHeaders() });
    }

    atualizar(id: number, data: any) {
        return this.http.put(`${SCAMP_API.accountApiV1}/estoque/${id}`, data, { headers: this.account.composeHeaders() });
    }

    delete(id: number) {
        return this.http.delete(`${SCAMP_API.accountApiV1}/estoque/${id}`, { headers: this.account.composeHeaders() });
    }

    buscarTodos(): Observable<any[]> {
        return this.http.get<any[]>(`${SCAMP_API.accountApiV1}/estoque`, { headers: this.account.composeHeaders() });
    }


}
